<template>
  <!-- <v-layout column wrap > -->
    <v-dialog v-model="dialogedit_role" max-width="500px" persistent max-height="500px" style="overflow-y: hidden; border-radius: 20px !important;" class="Kanit">

   <v-card class="Kanit">
      <v-card tile>

        <v-toolbar dark class="toolbareditdadmin">
          <v-toolbar-title >เปลี่ยนประเภทผู้ใช้งาน</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon @click="closeDialog()">
            <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card>
      <v-card-text style="height: auto !important; max-height: 90vh !important; overflow-y: scroll; margin-top: 20px;">
<!-- {{data_user}}
{{listRoleSelect}} -->
          <v-select
            :items="listRoleSelect"
            v-model="role"
            label="ประเภทบัญชี"
            outlined
            hide-details
            single-line
            style="margin-bottom: 10px;"
            class="Kanit"
          ></v-select>
           

           <div v-if="role !=='user' && role != ''">
              <v-select
                :items="itemsCompany"
                item-text="company_name"
                item-value="company_id"
                v-model="CompanyOwner"
                label="เลือกบริษัทเจ้าของ Account"
                outlined
                hide-details
                single-line
                style="margin-bottom: 10px;"
                class="Kanit"
              ></v-select>
           </div>

           <div v-if="role =='superadmin'">
         <v-text-field
            label="ชื่อผู้ใช้งาน"
            single-line
            outlined
            v-model="username"
            class="textfieldInput"
            style="margin-bottom: 5px;"
            :hide-details="checkusername()"
            :rules="usernameRules"
          ></v-text-field>
          <v-text-field
            label="รหัสผ่าน"
            single-line
            outlined
            v-model="password"
            type="password"
            class="textfieldInput"
            style="margin-bottom: 5px;"
            :hide-details="checkpassword()"
            :rules="passwordRules"
          ></v-text-field>
          <v-text-field
            label="ยืนยันรหัสผ่าน"
            single-line
            outlined
            :hide-details="checkrepassword()"
            :rules="repasswordRules"
            v-model="repassword"
            class="textfieldInput"
            type="password"
            style="margin-bottom: 5px;"
          ></v-text-field>
           </div>
        <v-btn rounded color="#a80f00" style="margin-top: 10px;text-transform: none; color: white;"  @click="closeDialog()" >ยกเลิก</v-btn>
        <v-btn rounded color="#a80f00" style="margin-top: 10px;text-transform: none; color: white;"  @click="changeRole()" :disabled="checkRoleOKBTN()">ตกลง</v-btn>
        
      </v-card-text>
    </v-card>
  <!-- </v-layout> -->

</v-dialog>
</template>
<script>
import { Decode } from '@/services'
export default {
  props: {
    dialogedit_role: false,
    data_user: {}
  },
  data: () => ({
    BASE_URL: process.env.BASE_URL,
    listRoleAccount: ['user','admin','superadmin', 'maintenance'],
    role: '',
    itemsCompany: [],
    CompanyOwner: '',
    username: '',
    password: '',
    repassword: '',
    usernameRules: [
      v => ((!v && v.length < 6) || /^[^\W_]+$/.test(v)) || 'ไม่สามารถใช้อักขระพิเศษได้',
      v => (!!v && v.length >= 6) || 'กรุณาใส่ตัวอักษรอย่างน้อย 6 ตัว',
      v => /^([^A-Z])+$/.test(v) || 'กรุณาใส่ชื่อผู้ใช้งานเป็นภาษาอังกฤษ a-z และ 0-9 เท่านั้น',
      v => /^([a-z])+$/.test(v) || /^((?=.*[a-z])(?=.*[0-9]).{6,})+$/.test(v) || 'กรุณาใส่ชื่อผู้ใช้งานที่ประกอบด้วยตัวอักษรภาษาอังกฤษ a-z อย่างน้อย1ตัว'
    ],
    passwordRules: [
      v => (!!v && v.length >= 6) || 'กรุณาใส่ตัวอักษรอย่างน้อย 6 ตัว'
    ]
  }),
  created () {
    var decode = Decode.decode(localStorage.getItem('key'))
    this.authen = JSON.parse(decode)
    this.headerAPI = {Authorization: this.authen.Authorization}
    this.typeCompanyDecode = this.authen.typeCompany
    this.idCompany = this.authen.idCompany
    this.nameCompany = this.authen.nameCompany
  },
  computed: {
    listRoleSelect () {
      var role = this.data_user.role
      return this.listRoleAccount.filter(function(item) {
        return item !== role
      })
    },
    repasswordRules() {
      return (this.password === this.repassword) || ['รหัสผ่านไม่ตรงกัน']
    }
  },
  watch: {
    role () {
      this.CompanyOwner = ''
      if (this.role === 'maintenance') {
        this.getCompanyMaintenance()
      } else {
        this.getCompanyOwner()
      }
    }
  },
  methods: {
    checkRoleOKBTN () {
      if (this.role == 'user' && this.data_user.userid) {
        return false
      } else if ((this.role == 'admin' || this.role == 'maintenance') && this.data_user.userid && this.CompanyOwner) {
        return false
      } else if (this.role == 'superadmin' && this.data_user.userid && this.CompanyOwner && this.username && this.password && (this.password === this.repassword)) {
        return false
      } else {
        return true
      }
    },
    changeRole () {
      // console.log(this.data_user)
      if (this.role == 'user') {
        var body = {
          "user_id": this.data_user.userid,
          "role_name": this.role
        }
      } else if (this.role == 'admin' || this.role == 'maintenance') {
        var body = {
          "user_id": this.data_user.userid,
          "role_name": this.role,
          "company_id": this.CompanyOwner
        }
      } else {
        var body = {
          "user_id": this.data_user.userid,
          "role_name": this.role,
          "company_id": this.CompanyOwner,
          "username": this.username,
          "password": this.password
        }
      }
      this.axios.post(process.env.API_BACKEND + '/v1/changeRoleUser', body, {headers: this.headerAPI}).then((response) => {
        // console.log(response.data)
        // this.itemsCompany = response.data.data
        if (this.role == 'user') {
          this.$router.push('/information_user?id='+response.data.data.userid)
        } else {
          this.$router.push('/information_admin?id='+response.data.data.generate_id)
        }
      }).catch((error) => {
        // console.log(error.response.data.message)
        if (error.response.data.message === 'username_is_duplicate') {
          this.$swal( 'ไม่สำเร็จ', 'ชื่อผู้ใช้งาน ซ้ำกับในระบบ', 'error' )
        }
      })
    },
    getCompanyOwner () {
      this.axios.get(process.env.API_BACKEND + '/v1/getCompanyOwner', {headers: this.headerAPI}).then((response) => {
        this.itemsCompany = response.data.data
      })
    },
    getCompanyMaintenance () {
      this.axios.get(process.env.API_BACKEND + '/v1/getCompanyMaintenance', {headers: this.headerAPI}).then((response) => {
        this.itemsCompany = response.data.data
      })
    },
    cancel () {
      this.company_name = this.Company.company_name
      this.company_detail = this.Company.company_detail
    },
    changeType () {
      if (this.Company.company_type === 'maintenance') {
        this.textType_company = 'บริษัทบำรุงรักษาเครื่อง AED'
      } else if (this.Company.company_type === 'owner') {
        this.textType_company = 'บริษัทในเครือสภากาชาด'
      } else if (this.Company.company_type === 'partner') {
        this.textType_company = 'บริษัทร่วมโครงการ'
      }
    },
    closeDialog () {
      this.role = ''
      this.$emit('closeedit_role', false)
    },
    editCompany () {
      var body = {
        company_id: this.Company.company_id,
        company_detail: this.company_detail,
        company_name: this.company_name
      }
      this.axios.post(process.env.API_BACKEND + '/v1/editCompany', body, {headers: this.headerAPI}).then((response) => {
        if (response.data.message === 'success') {
          // this.$swal( 'สำเร็จ', 'แก้ไขข้อมูล' + this.textType_company + 'สำเร็จแล้ว' , 'success' )
          this.closeDialog()
        } else {
          this.$swal( 'ไม่สำเร็จ', 'แก้ไขข้อมูล' + this.textType_company + 'ไม่สำเร็จแล้ว', 'error' )
          this.closeDialog()
        }
      })
    },
    getComapny () {
      this.axios.get(process.env.API_BACKEND + '/v1/getAllCompany', {headers: this.headerAPI}).then((response) => {
        if (response.data.message === 'success') {
          this.listHeade_company = _.reject(response.data.data, ['company_type', 'maintenance'])
        }
      })
    },
    btncancle () {
      this.username = ''
      this.password = ''
      this.repassword = ''
      this.company_name = ''
    },
    checkusername () {
      if (this.username == '') {
        return false
      } else if ((this.username !='' && this.username.length < 6)){
        return false
      } else if (!/^([^A-Z])+$/.test(this.username)){
        return false
      } else if (!/^([a-z])+$/.test(this.username) && !/^((?=.*[a-z])(?=.*[0-9]).{6,})+$/.test(this.username)){
        return false
      } else {
        return true
      }
    },
    checkrepassword () {
      // if ((this.repassword !='' && this.repassword.length < 6) || this.repassword !== this.password){
        return false
      // } else {
      //   return true
      // }
    },
    checkpassword () {
      if (this.password !='' && this.password.length < 6){
        return false
      } else {
        return true
      }
    }
  }
}
</script>
<style media="screen" scoped>
.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
>>>.v-textarea.v-text-field--enclosed.v-text-field--single-line .v-label {
  top: 10px !important;
}
>>>.v-list-item .v-list-item__title {
    font-family: 'Kanit', sans-serif !important;

}
.inputinfor_address {
  height: 110px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: white !important;
}
.inputinfor {
  height: 50px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: white !important;
}
.inputinfor_dis {
  height: 50px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: #FAF0F0 !important;
}
>>>.layout.wrap {
  flex-wrap: wrap;
}
>>>.v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
}
.toolbareditdadmin {
  border-top-color: transparent !important;
  border-left-color: transparent !important;
  border-width: thin !important;
  border-right-color: transparent !important;
  border-style: solid !important;
  height: 64px !important;
  border-left-style: initial !important;
  border-right-style: initial !important;
  border-radius: 0px !important;
  border-bottom-color: #a80e00 !important;
  background-color: #a80e00 !important;
  color: white !important;
  border-width: thin !important;
  box-shadow: none !important;
}
/* >>>.v-input__slot {
  border-radius: 10px !important;
  border-style: solid !important;
  border-width: thin !important;
  border-color: #a80f00 !important;
  background-color: #a80d0021 !important;
} */
.btngen {
  background-color: white !important;
  color: #a80f00 !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  text-transform: none !important;
  width: 120px !important;
}
.btnedituser {
  background-color: #a80f00 !important;
  color: #fafafa !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  text-transform: none !important;
}
.btnedituser:disabled {
  background-color: #a80f0099 !important;
  color: #fafafa9c !important;
  border-color: #a80f0091 !important;
  border-style: solid !important;
  border-width: thin !important;
}

.btncancle {
  background-color: #fafafa !important;
  color: #a80f00 !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  width: 160px !important;
}
>>>.theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
  background-color: #a80f0099 !important;
  color: #fafafa9c !important;
  border-color: #a80f0091 !important;
  border-style: solid !important;
  border-width: thin !important;
}


>>>.v-input .v-label {
    height: 30px;
    line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/edit/edit_role_modal.vue